<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Analysis Data
      </h2>
      <p class="tw-italic tw-text-gray-700">
        View/Download curated analysis data.
      </p>
    </b-container>

    <b-container fluid class="tw-my-5">
      <b-row>
        <b-col>
          <b-form-select size="lg" v-model="selected_view" :options="views" @change="resetPhase()"></b-form-select>
        </b-col>
        <b-col>
          <!-- <b-form-select :disabled="!selected_view.includes('Primary_First_Time_Infection')" size="lg" v-model="selected_phase" :options="study_phases"></b-form-select> -->
          <b-form-select size="lg" v-model="selected_phase" :options="study_phases"></b-form-select>
        </b-col>
        <b-col cols="auto">
          <b-button size="lg" @click="downloadFile()" variant="secondary" target="_blank" class="px-5">Download</b-button>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid>
        <b-table
      ref="table"
      striped
      hover
      responsive
      bordered
      :items="data"
      :fields="fields"
      :busy.sync="loading"
      :current-page="options.currentPage"
      :per-page="options.perPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    >
        <template v-slot:cell(age_at_enrollment)="data">
            {{parseFloat(data.value).toPrecision(2)}}
        </template>
    </b-table>
    </b-container>

    <b-pagination
      v-model="options.currentPage"
      :total-rows="options.totalRows"
      :per-page="options.perPage"
      align="right"
      size="sm"
      class="my-0"
    ></b-pagination>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import * as _ from "lodash";

export default {
  mixins: [DashboardBaseTemplate],
  data() {
    return {
      options: {
        currentPage: 1,
        totalRows: 0,
        perPage: 30,
      },
      loading: false,
      search: "",
      fields: [],
      data: [],
      sortBy: "id",
      sortDesc: false,
      title: "",
      totalItems: 0,
      stacked: false,
      selected_view: "Primary_First_Time_Infection_Pes",
      views: [
        /*{
          value: "Final_PE_Baseline_Epidemiological_Analysis_Data",
          text: "Final PE Baseline Epidemiological Analysis Data",
        },
        {
          value: "Final_PE_Intervention_Epidemiological_Analysis_Data",
          text: "Final PE Intervention Epidemiological Analysis Data",
        },
        {
          value: "Final_SE_ALL_Entomological_Analysis_Data",
          text: "Final SE ALL Entomological Analysis Data",
        },*/

        {
          value: "Primary_First_Time_Infection_Pes",
          text: "Primary First Time Infection Pes"
        },
        {
          value: "Secondary_Entomology_Treatment_Allocation_By_Visits",
          text: "Secondary Entomology Treatment Allocation By Visits"
        },
        {
          value: "Secondary_Overall_Infection_Pes",
          text: "Secondary Overall Infection Pes"
        },
        {
          value: "Product_Placement_Structure_List",
          text: "Product Placement/Replacement Structure"
        },
        {
          value: "Product_Placement_Room_List",
          text: "Product Placement/Replacement Room"
        },
        {
          value: "Entomology_Light_Trap_Dataset",
          text: "Entomology Light Trap Dataset"
        },
        {
          value: "Entomology_HLC_Dataset",
          text: "Entomology HLC Dataset"
        },
        {
          value: "AE_SAE_Symptoms_Report",
          text: "AE SAE Symptoms Report"
        },
      ],
      study_phases: [
        "All", 
        "Baseline",
        "Cohort 1",
        "Cohort 2"
      ],
      selected_phase: "All"
    };
  },
  computed: {},
  watch: {
    selected_view: function() {
      // this.$refs.table.refresh();
      this.find();
      this.options.currentPage = 1;
    },
    selected_phase: function() {
      this.find();
      this.options.currentPage = 1;
    }
  },
  created() {
    if (this.STUDY == "kenya") {
      this.views = [...this.views, ...
        [
          {
            value: 'Kenya Application Rate.json',
            text: 'Kenya Application Rate'
          },
          {
            value: 'Kenya Cluster Coverage.json',
            text: 'Kenya Cluster Coverage'
          },
          {
            value: "D0 - Ento (HLC) and Structure Member Observation Dates",
            text: "D0 - Ento (HLC) and Structure Member Observation Dates"
          },
          {
            value: "D00-2 - Ento HLC and SMO Dates",
            text: "D00-2 - Ento HLC and SMO Dates"
          },
          {
            value: "D1 - FTI Core Zones",
            text: "D1 - FTI Core Zones"
          },
          {
            value: "D2 - FTI Core Zones - Species",
            text: "D2 - FTI Core Zones - Species"
          },
          {
            value: "D3 - FTI Buffer Zones",
            text: "D3 - FTI Buffer Zones"
          },
          {
            value: "D4 - Ento (HLC) Core",
            text: "D4 - Ento (HLC) Core"
          },
          {
            value: "D5 - Ento (LT) Core and Buffer",
            text: "D5 - Ento (LT) Core and Buffer"
          },
          {
            value: "D6 - AE SAE Summary",
            text: "D6 - AE SAE Summary"
          },
          {
            value: "D6-2 - AE SAE Summary",
            text: "D6-2 - AE SAE Summary"
          },
          {
            value: "D6-3 - AE SAE Summary",
            text: "D6-3 - AE SAE Summary"
          },
          {
            value: "D7 - Ento (HLC) - Number of People",
            text: "D7 - Ento (HLC) - Number of People"
          },
          {
            value: "D8 - FTI Core Zones - Travel",
            text: "D8 - FTI Core Zones - Travel"
          },
          {
            value: "D9",
            text: "D9"
          },
          {
            value: "D9-trim",
            text: "D9-trim"
          },
          {
            value: "D10 - Observation Data",
            text: "D10 - Observation Data"
          },
          {
            value: "D11: NA",
            text: "D11: NA"
          },
          {
            value: "D11.2 - Barcode Summary",
            text: "D11.2 - Barcode Summary"
          },
          {
            value: "Product_Placement_Household_List",
            text: "Product Placement/Replacement Household"
          },
        ]
        ]
    }
    if (this.STUDY == "mali") {
        this.study_phases = [
        "All",
        "Baseline",
        "Intervention"
      ]
      this.views = [...this.views, ...
        [
          {
            value: "D1 - Epi",
            text: "D1 - Epi"
          },
          {
            value: "D1.2 - Epi",
            text: "D1.2 - Epi"
          },
          {
            value: "D2 - Application Rate",
            text: "D2 - Application Rate"
          },
          {
            value: 'D2.1 - Application Rate Final Status',
            text: 'D2.1 - Application Rate Final Status'
          },
          {
            value: 'D2.2 - Application Rate (Cluster)',
            text: 'D2.2 - Application Rate (Cluster)'
          },
          {
            value: "D3 - Ento (HLC)",
            text: "D3 - Ento (HLC)"
          },
          {
            value: "D4 - Ento (LT)",
            text: "D4 - Ento (LT)"
          },
          {
            value: "D5 - Safety",
            text: "D5 - Safety"
          },
          {
            value: "D8 - Epi",
            text: "D8 - Epi"
          },
          {
            value: "D8.2 - Epi",
            text: "D8.2 - Epi"
          },
          {
            value: "D9 - Coverage",
            text: "D9 - Coverage"
          },
          {
            value: "D11: NA",
            text: "D11: NA"
          },
          {
            value: "D11.2 - Barcode Summary",
            text: "D11.2 - Barcode Summary"
          },
          {
            value: "D11: ROSS",
            text: "D11: ROSS"
          },
          {
            value: "D11.2 - ROSS Summary",
            text: "D11.2 - ROSS Summary"
          },
        ]
      ]
    }
    // Add 60 options for D11
    for (let i = 1; i < 61; i++) {
      // if we're in kenya, convert i to a two-digit string
      if (this.STUDY == "kenya") {
        i = i.toString().padStart(2, '0');
      }
      this.views.push({
        value: `D11: ${i}`,
        text: `D11: ${i}`
      })
    }
    this.find();
  },
  methods: {
    resetPhase() {
      this.selected_phase = "All"
    },
    find() {
      const that = this;
      let params = {
        analysis: that.selected_view,
      };
      
      // if (that.selected_view.includes("Primary_First_Time_Infection")) {
      params.study_phase = that.selected_phase;
      // }
      
      return HTTP.get("/kenya/analysis", {
        params: params
      })
      .then((response) => {
        let fields = [];
        _.each(response.data.fields, function(field) {
          fields.push({
            key: field,
            sortable: true,
          });
        });
        that.fields = fields;

        that.data = response.data.data;
        that.options.totalRows = that.data.length;
        that.totalItems = that.data.length;
      })
      .catch((error) => {
        HandleErrors.HandleErrors(error);
      });
    },
    downloadFile: function() {
      const that = this;
      let downloadUrl = `${process.env.VUE_APP_AXIOS_BASE_URL}/kenya/analysis?download=1&analysis=${that.selected_view}`;
      
      // if (that.selected_view.includes("Primary_First_Time_Infection")) {
      downloadUrl += `&study_phase=${that.selected_phase}`;
      // }

      HTTP.get(downloadUrl).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        // fileLink.setAttribute('download', `${that.selected_view}.csv`);
        const now = new Date();
        fileLink.setAttribute('download', `${that.selected_view}_${now}.csv`);
        document.body.appendChild(fileLink);
        fileLink.click();
      }).catch((error) => {
        HandleErrors.HandleErrors(error);
      });
    }
  },
};
</script>

<style></style>
